import productImage from '@/public/next/img/landing/features/product.png'
import productPositionImage from '@/public/next/img/landing/features/product/position.png'
import productLostProfitImage from '@/public/next/img/landing/features/product/lost-profit.png'
import productAvailabilityImage from '@/public/next/img/landing/features/product/availability.png'
import productContentImage from '@/public/next/img/landing/features/product/content.png'
import categoryImage from '@/public/next/img/landing/features/category.png'
import categoryStatsImage from '@/public/next/img/landing/features/category/stats.png'
import categoryHistoryImage from '@/public/next/img/landing/features/category/history.png'
import categoryPriceDistributionImage from '@/public/next/img/landing/features/category/price-distribution.png'
import categoryMonopolizationImage from '@/public/next/img/landing/features/category/monopolization.png'
import categoryMerchantsAndBrandsImage from '@/public/next/img/landing/features/category/merchants-and-brands.png'
import keywordsOzonImage from '@/public/next/img/landing/features/keywords-ozon.png'
import keywordsWbImage from '@/public/next/img/landing/features/keywords-wb.png'
import keywordsDataImage from '@/public/next/img/landing/features/keywords/data.png'
import keywordsResultsImage from '@/public/next/img/landing/features/keywords/results.png'
import keywordsFilterImage from '@/public/next/img/landing/features/keywords/filter.png'
import keywordsTrendsImage from '@/public/next/img/landing/features/keywords/trends.png'
import keywordsDemandMetricsWbImage from '@/public/next/img/landing/features/keywords/demand-metrics-wb.png'
import keywordsDemandMetricsOzonImage from '@/public/next/img/landing/features/keywords/demand-metrics-ozon.png'
import keywordsDemandAnalyticsImage from '@/public/next/img/landing/features/keywords/demand-analytics.png'
import salesImage from '@/public/next/img/landing/internal-analytics.png'
import salesExpensesImage from '@/public/next/img/landing/features/sales/expenses.png'
import salesAbcImage from '@/public/next/img/landing/features/sales/abc.png'
import salesOrdersImage from '@/public/next/img/landing/features/sales/orders.png'
import salesMarketplaceRevenueImage from '@/public/next/img/landing/features/sales/marketplace-revenue.png'
import supplyPlanningImage from '@/public/next/img/landing/features/supply-planning.png'
import supplyPlanningEndedImage from '@/public/next/img/landing/features/supply-planning/ended.png'
import supplyPlanningDataImage from '@/public/next/img/landing/features/supply-planning/data.png'
import supplyPlanningStatsImage from '@/public/next/img/landing/features/supply-planning/stats.png'
import supplyPlanningDetailsImage from '@/public/next/img/landing/features/supply-planning/details.png'
import bidderImage from '@/public/next/img/landing/features/bidder.png'
import bidderTooltipImage from '@/public/next/img/landing/features/bidder/tooltip.png'
import bidderScheduleImage from '@/public/next/img/landing/features/bidder/schedule.png'
import bidderStatsImage from '@/public/next/img/landing/features/bidder/stats.png'
import bidderAutoPriceImage from '@/public/next/img/landing/features/bidder/auto-price.png'
import repricerWbImage from '@/public/next/img/landing/features/repricer-wb.png'
import repricerOzonImage from '@/public/next/img/landing/features/repricer-ozon.png'
import repricerTooltipWbImage from '@/public/next/img/landing/features/repricer/tooltip-wb.png'
import repricerTooltipOzonImage from '@/public/next/img/landing/features/repricer/tooltip-ozon.png'
import repricerFixPriceImage from '@/public/next/img/landing/features/repricer/fix-price.png'
import repricerListImage from '@/public/next/img/landing/features/repricer/list.png'
import repricerScheduleImage from '@/public/next/img/landing/features/repricer/schedule.png'
import reviewsImage from '@/public/next/img/landing/features/reviews.png'
import reviewsAiReplyImage from '@/public/next/img/landing/features/reviews/ai-reply.png'
import reviewsScoreImage from '@/public/next/img/landing/features/reviews/score.png'
import reviewsAiTagsImage from '@/public/next/img/landing/features/reviews/ai-tags.png'
import reviewsAiModerationImage from '@/public/next/img/landing/features/reviews/ai-moderation.png'
import reviewsStopwordsImage from '@/public/next/img/landing/features/reviews/stopwords.png'
import toolsDescriptionGenerationImage from '@/public/next/img/landing/features/tools/description-generation.png'
import toolsImageGenerationImage from '@/public/next/img/landing/features/tools/image-generation.png'
import toolsSeoOptimizationImage from '@/public/next/img/landing/features/tools/seo-optimization.png'
import toolsUnitEconomicsImage from '@/public/next/img/landing/features/tools/unit-economics.png'
import toolsExternalAdvertisingImage from '@/public/next/img/landing/features/tools/external-advertising.png'
import toolsTgBotImage from '@/public/next/img/landing/features/tools/tg-bot.png'
import toolsNicheAnalysisImage from '@/public/next/img/landing/features/tools/niche-analysis.png'
import toolsPositionMonitoringImage from '@/public/next/img/landing/features/tools/position-monitoring.png'
import toolsRecommendationPositionsImage from '@/public/next/img/landing/features/tools/recommendation-positions.png'
import toolsVideoGenerationImage from '@/public/next/img/landing/features/tools/video-generation.png'
import toolsAiAssistantImage from '@/public/next/img/landing/features/tools/ai-assistant.png'
import toolsAiAuditImage from '@/public/next/img/landing/features/tools/ai-audit.png'

type Mall = 'wb' | 'ozon' | 'beru'
type StaticImage = { src: string; width: number; height: number }

const alignmentStyles = {
  topLeft: '-top-4 left-24',
  topRight: '-top-4 right-24',
  centerLeft: 'inset-y-0 lg:my-auto left-2 lg:-translate-y-2',
  centerRight: 'inset-y-0 lg:my-auto right-2 lg:-translate-y-2',
  bottomLeft: '-bottom-16 xl:-bottom-12 left-24',
  bottomRight: '-bottom-16 xl:-bottom-12 right-24',
}

const resetAbsoluteStyles = {
  wrapper: '!grid !gap-4',
  item: '!static !shadow-none !max-w-none !h-full',
}

const sellmonitorFeatures: {
  title: string
  malls: Mall[]
  benefit: string
  mainImage?: StaticImage
  link?: string
  className?: string
  gridClassName?: Partial<Record<string, string>>
  items: {
    description: string
    image?: StaticImage
    className?: string
    malls?: Mall[]
    link?: string
  }[]
}[] = [
  {
    title: 'Внутренняя аналитика',
    link: '/financial-analytics/',
    malls: ['wb', 'ozon', 'beru'],
    mainImage: salesImage,
    benefit: 'Финансовая прозрачность ваших магазинов',
    items: [
      {
        description: 'Реальная выручка, расходы и прибыль по магазину и по каждому товару',
        className: alignmentStyles.centerLeft,
      },
      {
        description: 'Структура и динамика расходов',
        image: salesExpensesImage,
        className: 'inset-y-0 lg:my-auto right-2 lg:translate-y-12',
      },
      {
        description: 'ABC‑анализ прибыли и выручки',
        image: salesAbcImage,
        className: alignmentStyles.bottomLeft,
      },
      {
        description: 'Динамика заказов, отмен и возвратов',
        image: salesOrdersImage,
        className: alignmentStyles.bottomRight,
        malls: ['wb', 'ozon', 'beru'],
      },
      {
        description: 'Сводная аналитика магазинов и маркетплейсов',
        image: salesMarketplaceRevenueImage,
        className: alignmentStyles.topRight,
      },
    ],
  },
  {
    title: 'Управление ценами',
    malls: ['wb'],
    mainImage: repricerWbImage,
    link: '/repricer/',
    benefit: 'Поможем контролировать цену на ваши товары',
    items: [
      {
        description: 'Отслеживаем цены на ваши товары каждую минуту и держим их под контролем',
        image: repricerTooltipWbImage,
        className: alignmentStyles.centerLeft,
      },
      {
        description: 'Фиксированная цена — позволяет не участвовать в акциях',
        image: repricerFixPriceImage,
        className: alignmentStyles.centerRight,
      },
      {
        description: 'Покажем подробную историю изменений цены с причинами',
        image: repricerListImage,
        className: alignmentStyles.bottomLeft,
      },
      {
        description: 'Изменим цену в зависимости от остатков, времени суток или цен конкурентов',
        image: repricerScheduleImage,
        className: alignmentStyles.bottomRight,
      },
      {
        description: 'Рассчитываем цену по заданной маржинальности',
        className: alignmentStyles.topLeft,
      },
      {
        description: 'Управляем участием в акциях с заданным пределом снижения цены',
        className: alignmentStyles.topRight,
      },
    ],
  },
  {
    title: 'Управление ценами',
    malls: ['ozon'],
    mainImage: repricerOzonImage,
    link: '/repricer/',
    benefit: 'Поможем контролировать цену на ваши товары',
    items: [
      {
        description: 'Отслеживаем цены на ваши товары каждую минуту и держим их под контролем',
        image: repricerTooltipOzonImage,
        className: alignmentStyles.centerLeft,
      },
      {
        description: 'Фиксированная цена — позволяет не участвовать в акциях',
        image: repricerFixPriceImage,
        className: alignmentStyles.centerRight,
      },
      {
        description: 'Покажем подробную историю изменений цены с причинами',
        image: repricerListImage,
        className: alignmentStyles.bottomLeft,
      },
      {
        description: 'Изменим цену в зависимости от остатков, времени суток или цен конкурентов',
        image: repricerScheduleImage,
        className: alignmentStyles.bottomRight,
      },
      {
        description: 'Рассчитываем цену по заданной маржинальности',
        className: alignmentStyles.topLeft,
      },
      {
        description: 'Управляем участием в акциях с заданным пределом снижения цены',
        className: alignmentStyles.topRight,
      },
    ],
  },
  {
    title: 'Управление рекламой',
    malls: ['wb'],
    mainImage: bidderImage,
    link: '/bidder/',
    benefit: 'Поможем контролировать расходы на продвижение товаров',
    items: [
      {
        description: 'Проверяем позиции избранных кластеров каждые 5 минут и при необходимости меняем ставку',
        image: bidderTooltipImage,
        className: alignmentStyles.centerLeft,
      },
      {
        description: 'Выбирайте часы работы рекламы по тепловой карте',
        image: bidderScheduleImage,
        className: alignmentStyles.centerRight,
      },
      {
        description: 'Покажем позицию, просмотры, клики и расходы рекламы в кластерах',
        image: bidderStatsImage,
        className: alignmentStyles.bottomLeft,
      },
      {
        description: 'Автоматическое пополнение бюджета и лимит расходов за день',
        image: bidderAutoPriceImage,
        className: alignmentStyles.bottomRight,
      },
      {
        description: 'Три стратегии управления ставками: оптимальная позиция, наивысшая позиция и фиксированная ставка',
        className: alignmentStyles.topRight,
      },
    ],
  },
  {
    title: 'Автоответы на отзывы',
    link: '/review-autoreplier/',
    malls: ['wb', 'ozon', 'beru'],
    mainImage: reviewsImage,
    className: 'lg:pb-32 xl:pb-0',
    benefit: 'Создавайте доверие к товару и управляйте репутацией бренда',
    items: [
      {
        description: 'ИИ определяет тему и настроение отзыва',
        image: reviewsAiTagsImage,
        className: alignmentStyles.centerLeft,
      },
      {
        description: 'Правила ответа по оценке, теме отзыва, товару и бренду',
        image: reviewsScoreImage,
        className: alignmentStyles.centerRight,
      },
      {
        description: 'ИИ отвечает по тексту отзыва или вашим шаблонам',
        image: reviewsAiReplyImage,
        className: alignmentStyles.bottomLeft,
      },
      {
        description: 'Если одно из стоп-слов есть в отзыве, то мы не будем на него отвечать',
        image: reviewsStopwordsImage,
        className: alignmentStyles.bottomRight,
      },
      {
        description: 'Поможем автоматически отвечать на отзывы пользователей',
        className: alignmentStyles.topLeft,
      },
      {
        description: 'Проверка ИИ-ответов перед отправкой покупателю',
        image: reviewsAiModerationImage,
        className: alignmentStyles.topRight,
      },
    ],
  },
  {
    title: 'Планирование поставок',
    malls: ['wb', 'ozon', 'beru'],
    mainImage: supplyPlanningImage,
    link: '/supply-planning/',
    benefit: 'Поможем спланировать пополнение запасов товаров на складе',
    items: [
      {
        description: 'Покажем, какие товары требуют поставки',
        image: supplyPlanningEndedImage,
        className: alignmentStyles.centerLeft,
      },
      {
        description: 'Расчёт количества товара и суммы планируемой поставки',
        image: supplyPlanningDataImage,
        className: alignmentStyles.centerRight,
      },
      {
        description: 'Распределение поставки по складам',
        image: supplyPlanningStatsImage,
        className: alignmentStyles.bottomLeft,
        malls: ['wb', 'ozon', 'beru'],
      },
      {
        description: 'Подробный расчёт поставки по каждому товару',
        image: supplyPlanningDetailsImage,
        className: alignmentStyles.bottomRight,
      },
    ],
  },
  {
    title: 'Товары',
    malls: ['wb', 'ozon', 'beru'],
    mainImage: productImage,
    benefit: 'Cобираем данные по каждому товару',
    items: [
      {
        description: 'История цен, остатков на складе, выручки и продаж',
        className: alignmentStyles.topLeft,
      },
      {
        description: 'Позиции карточки в поиске по запросам',
        image: productPositionImage,
        className: alignmentStyles.centerLeft,
        malls: ['wb', 'ozon', 'beru'],
      },
      {
        description: 'Оценка упущенной выручки по товару',
        image: productLostProfitImage,
        className: alignmentStyles.centerRight,
      },
      {
        description: 'Когда товар был в продаже, закончился или был удалён',
        image: productAvailabilityImage,
        className: alignmentStyles.bottomLeft,
      },
      {
        description: 'Как менялся контент карточки',
        image: productContentImage,
        className: alignmentStyles.bottomRight,
      },
      {
        description: 'Сравнение до четырёх товаров по показателям и позициям в поиске',
        className: alignmentStyles.topRight,
      },
    ],
  },
  {
    title: 'Категории, магазины и бренды',
    malls: ['wb', 'ozon', 'beru'],
    mainImage: categoryImage,
    className: 'lg:pb-16 xl:pb-0',
    benefit: 'Анализ категорий, магазинов и брендов для оценки рынка и конкурентов',
    items: [
      {
        description: 'Выручка, продажи и средняя цена по категории',
        image: categoryStatsImage,
        className: alignmentStyles.centerLeft,
      },
      {
        description: 'История и сезонность продаж по категории',
        image: categoryHistoryImage,
        className: 'inset-y-0 lg:my-auto right-2 lg:translate-y-4 xl:-translate-y-2',
      },
      {
        description: 'Распределение выручки и товаров по ценовым диапазонам в категории',
        image: categoryPriceDistributionImage,
        className: alignmentStyles.bottomLeft,
      },
      {
        description: 'Распределение выручки между магазинами и брендами в категории',
        image: categoryMonopolizationImage,
        className: alignmentStyles.bottomRight,
      },
      {
        description: 'Ассортимент, продажи и выручка магазинов и брендов',
        image: categoryMerchantsAndBrandsImage,
        className: alignmentStyles.topRight,
      },
    ],
  },
  {
    title: 'Поисковые запросы',
    malls: ['wb'],
    mainImage: keywordsWbImage,
    className: 'lg:pb-16 xl:pb-0',
    benefit: 'Помогаем сформировать стратегию продвижения',
    items: [
      {
        description: 'История популярности и сезонности поискового запроса',
        image: keywordsDataImage,
        className: 'inset-y-0 lg:my-auto left-2 lg:translate-y-4 xl:-translate-y-2',
      },
      {
        description: 'Оценка представленности конкурентов по поисковому запросу',
        image: keywordsResultsImage,
        className: 'inset-y-0 lg:my-auto right-2 lg:translate-y-4 xl:-translate-y-2',
      },
      {
        description: 'Поисковые запросы по категориям',
        image: keywordsFilterImage,
        className: alignmentStyles.bottomLeft,
      },
      {
        description: 'Подборки трендовых запросов',
        image: keywordsTrendsImage,
        className: alignmentStyles.bottomRight,
      },
      {
        description: 'Просмотры, корзины, заказы и конверсия по запросу',
        image: keywordsDemandMetricsWbImage,
        className: alignmentStyles.topLeft,
      },
      {
        description: 'Аналитика спроса по предметам и поисковым запросам',
        image: keywordsDemandAnalyticsImage,
        className: alignmentStyles.topRight,
      },
    ],
  },
  {
    title: 'Поисковые запросы',
    malls: ['ozon'],
    mainImage: keywordsOzonImage,
    benefit: 'Помогаем сформировать стратегию продвижения',
    items: [
      {
        description: 'История популярности и сезонности поискового запроса',
        image: keywordsDataImage,
        className: alignmentStyles.centerLeft,
      },
      {
        description: 'Оценка представленности конкурентов по поисковому запросу',
        image: keywordsResultsImage,
        className: alignmentStyles.centerRight,
      },
      {
        description: 'Добавления в корзину и конверсия по запросу',
        image: keywordsDemandMetricsOzonImage,
        className: alignmentStyles.bottomLeft,
      },
      {
        description: 'Подборки трендовых запросов',
        image: keywordsTrendsImage,
        className: alignmentStyles.bottomRight,
      },
    ],
  },
  {
    title: 'Инструменты и автоматизация',
    malls: ['wb', 'ozon', 'beru'],
    className: resetAbsoluteStyles.wrapper,
    gridClassName: {
      beru: 'md:!grid-cols-2',
    },
    benefit: 'Инструменты для быстрого управления магазином',
    items: [
      {
        description: 'Генерация описания карточки товара',
        image: toolsDescriptionGenerationImage,
        className: resetAbsoluteStyles.item,
        malls: ['wb', 'ozon', 'beru'],
      },
      {
        description: 'Генерация и редактирование изображений для карточки товара',
        image: toolsImageGenerationImage,
        className: resetAbsoluteStyles.item,
        malls: ['wb', 'ozon', 'beru'],
      },
      {
        description: 'Генерация видео для карточки товара по текстовому описанию или изображению',
        image: toolsVideoGenerationImage,
        className: resetAbsoluteStyles.item,
      },
      {
        description: 'ИИ-ассистент: вопросы о сервисе, идеи для товаров и помощь с расчётами',
        image: toolsAiAssistantImage,
        className: resetAbsoluteStyles.item,
      },
      {
        description: 'ИИ-аудит изображений, описания и отзывов товара с рекомендациями по улучшению',
        image: toolsAiAuditImage,
        className: resetAbsoluteStyles.item,
      },
      {
        description: 'SEO-оптимизация описания карточки товара',
        image: toolsSeoOptimizationImage,
        className: resetAbsoluteStyles.item,
        link: '/seo-optimization/',
        malls: ['wb', 'ozon'],
      },
      {
        description: 'Калькулятор юнит‑экономики',
        image: toolsUnitEconomicsImage,
        className: resetAbsoluteStyles.item,
        malls: ['wb', 'ozon'],
      },
      {
        description: 'Мониторинг внешней рекламы',
        image: toolsExternalAdvertisingImage,
        className: resetAbsoluteStyles.item,
        malls: ['wb', 'ozon'],
      },
      {
        description: 'Бот в Telegram и Макс с уведомлениями о продажах, выручке и заказах',
        image: toolsTgBotImage,
        className: resetAbsoluteStyles.item,
        malls: ['wb', 'ozon'],
      },
      {
        description: 'Анализ ниш по выручке, конкуренции и оборачиваемости товаров',
        image: toolsNicheAnalysisImage,
        className: resetAbsoluteStyles.item,
        malls: ['wb'],
      },
      {
        description: 'Мониторинг позиций товаров по выбранным поисковым запросам и история изменений',
        image: toolsPositionMonitoringImage,
        className: resetAbsoluteStyles.item,
      },
      {
        description: 'Сравнение позиций товаров в рекомендательных полках',
        image: toolsRecommendationPositionsImage,
        className: resetAbsoluteStyles.item,
        malls: ['wb'],
      },
    ],
  },
]

export default sellmonitorFeatures
